module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"siteList":"Site list"},"fr":{"siteList":"Liste des sites"}}')
  delete Component.options._Ctor
}
